export interface ThemePreset {
  label: string
  colors: Record<string, string>
}

export const themePresets: Record<string, ThemePreset> = {
  'immotron-red': {
    label: 'Immotron Rot',
    colors: {
      '--color-primary-50': '254 242 243',
      '--color-primary-100': '253 230 232',
      '--color-primary-200': '252 205 210',
      '--color-primary-300': '249 163 173',
      '--color-primary-400': '245 107 124',
      '--color-primary-500': '237 58 80',
      '--color-primary-600': '246 32 57',
      '--color-primary-700': '201 16 42',
      '--color-primary-800': '168 17 42',
      '--color-primary-900': '143 19 41',
      '--color-primary-950': '77 5 17',
    },
  },
  'default-blue': {
    label: 'Default Blau',
    colors: {
      '--color-primary-50': '239 246 255',
      '--color-primary-100': '219 234 254',
      '--color-primary-200': '191 219 254',
      '--color-primary-300': '147 197 253',
      '--color-primary-400': '96 165 250',
      '--color-primary-500': '59 130 246',
      '--color-primary-600': '37 99 235',
      '--color-primary-700': '29 78 216',
      '--color-primary-800': '30 64 175',
      '--color-primary-900': '30 58 138',
      '--color-primary-950': '23 37 84',
    },
  },
}

export function applyTheme(presetKey: string): void {
  const preset = themePresets[presetKey]
  if (!preset) return

  const root = document.documentElement
  for (const [prop, value] of Object.entries(preset.colors)) {
    root.style.setProperty(prop, value)
  }
}
